import {debounce} from "lodash/function";

window.MyTabs = {
	
	init: function() {
		
		$('.tab-title a', '.tab-container').bind('click',function(){
			var id = $(this).attr('id');
			$('.tab-title').find('a:not(#'+id+')').removeClass('current');
			$(this).addClass('current');
			var tabContent = $(this).closest('.tab-container').find('.tab-content');
			tabContent.find('#content_'+id).show();
			tabContent.find('>div:not(#content_'+id+')').hide();
			MyFacture.customForm();
		});
		
		var maxHeight = 0;
		$('.tab-content > div').each(function(){
			if($(this).height() > maxHeight){
				maxHeight = $(this).height();
			}
		});
		
		$('.tab-content').css("min-height", maxHeight);
	},
	
	
	initVertical: function(containerId, options){
		
		var loader = '<div class="tab-v-loader"><i class="fa fa-spin fa-spinner"><xsl:comment /></i></div>';

		var settings = $.extend({
			callback: ''
		}, options);
		
		var container  = $('#'+containerId);
		var tabContent = $(container).find('.tab-v-content');
        
        tabContent.each(function() {
			
			var tab = $(this);
			var currentMenuItem = tab.closest('div.tab-v-container').find('.tab-v-menu li.current a');
			var currentTabId = currentMenuItem.attr('id');
			
			tab.find('#content_'+currentTabId).show();
			tab.find('>div:not(#content_'+currentTabId+')').hide();

			var callback = currentMenuItem.attr('callback');
			if(callback != undefined){
				eval(callback);
			}
		});
		
		
		$(container).find('.tab-v-menu>li>a', '.tab-v-container').on('click', debounce(function(){
			var id		= $(this).attr('id');
			var item	= $(this); 
			
			if ($('.tab-v-breadcrum')){
				$('.tab-v-breadcrum').html(" > " + $(this).find('.tab-label').html());
			}
			
			var tabContent = $(this).closest('.tab-v-container').find('.tab-v-content');
			var callback	=  $(this).attr('callback');
			
			if($.isFunction(settings.callback)) {
				settings.callback.call(item, item);
			}		
			
			
			if($(this).closest('li').find('.tab-v-submenu').length > 0){
				$(this).closest('li').find('.tab-v-submenu').slideToggle(300);
			}else{
				$(this).closest('.tab-v-menu').find('li .tab-v-submenu:visible').slideUp('fast');
				$(this).closest('.tab-v-menu').find('li').removeClass('current');
				
				$(this).closest('li').addClass('current');
				
				var tabContent = $(this).closest('.tab-v-container').find('.tab-v-content:first');
				var callback =  $(this).attr('callback');

				if (callback != undefined && tabContent.find('#content_'+id).html() === ''){
					$('.tab-v-content').append(loader);
				}

				tabContent.find('#content_'+id).fadeIn(300, function(){
					if(callback != undefined){
						eval(callback);
						$('.tab-v-content .tab-v-loader').remove();
					}
				});
				
				tabContent.find('>div:not(#content_'+id+')').hide();
				
			}
			
			MyFacture.customForm('#content_'+id);
		}, 500));
		
		
		$(container).find('.tab-v-submenu li a', '.tab-v-container').bind('click', function(){
			var id = $(this).closest('ul').closest('li').find('a').attr('id');
			var label = $(this).text();
			var item = $(this);

            $(this).closest('.tab-v-menu').find('li a').removeClass("active");
			item.addClass("active");
			
			if($.isFunction(settings.callback)) {
				settings.callback.call(item, item);
			}
			
			$(this).closest('.tab-v-menu').find('li').removeClass('current');
			// $(this).closest('.tab-v-menu').find('li ul:visible').slideUp(300);

			$(this).closest('ul').closest('li').addClass('current');
			$(this).closest('ul').closest('li:not(.overflowTab)').addClass('current').find('span.tab-label').text(label);

			var tabContent = $(this).closest('.tab-v-container').find('.tab-v-content:first');
			var callback =  $(this).attr('callback');

			tabContent.find('#content_'+id).fadeIn(300, function(){
				if(callback != undefined){ 
					eval(callback);
				}
			});

			/** Patch added by aguerin (w cjulia) due to Vue js sub tab on overview
			 * it was done like this, because overview will be rebuilt into VueJs
			 * so, we'll don't need this Patch anymore after */
            if ($(this).attr('useVue') !== undefined) {
                var id = $(this).attr('id');
            }
			tabContent.find('>div:not(#content_'+id+')').hide();
			MyFacture.customForm('#content_'+id);
		});

	},
	
	initHorizontal: function(containerId, options) {

		var loader = '<div class="tab-h-loader"><i class="fa fa-spin fa-spinner"><xsl:comment /></i></div>';

		var settings = $.extend({
			callback: '',
		}, options);
		
		var container = $('#'+containerId);
		
		var currentTabId = $(container).find('.tab-h-menu li.current a').attr('id');
		var tabContent = $(container).find('.tab-h-content');
		
		if($(container).find('.tab-h-menu li.current a').attr('callback') != ''){
			eval($(container).find('.tab-h-menu li.current a').attr('callback'));
		}
		
		tabContent.each(function() {
			
			var tab = $(this);
			var currentTabId = tab.closest('div.tab-h-container').find('.tab-h-menu li.current a').attr('id');
			
			tab.find('#content_'+currentTabId).show();
			tab.find('>div:not(#content_'+currentTabId+')').hide();
		});
		
		
		$(container).find('.tab-h-menu>li>a', '.tab-h-container').bind('click',function(){
			
			var id = $(this).attr('id');
			var item = $(this);
			
			var tabContent = $(this).closest('.tab-h-container').find('.tab-h-content');
			var callback =  $(this).attr('callback');
			
			if($.isFunction(settings.callback)) {
				settings.callback.call(item, item);
			}		
			
			
			if($(this).closest('li').find('.tab-h-submenu').length > 0){
				$(this).closest('li').find('.tab-h-submenu').slideToggle(300);
			}else{
				$(this).closest('.tab-h-menu').find('li .tab-h-submenu:visible').slideUp('fast');
				$(this).closest('.tab-h-menu').find('li').removeClass('current');
				
				$(this).closest('li').addClass('current');
				
				var tabContent = $(this).closest('.tab-h-container').find('.tab-h-content:first');
				var callback =  $(this).attr('callback');

				if (callback != undefined && tabContent.find('#content_'+id).html() == ''){
					$('.tab-h-content').append(loader);
				}

				tabContent.find('#content_'+id).fadeIn(300, function(){
					if(callback != undefined){
						eval(callback);
						$('.tab-h-content .tab-h-loader').remove();
					}
				});
				
				tabContent.find('>div:not(#content_'+id+')').hide();
				
			}
			
			MyFacture.customForm('#content_'+id);
		});
		
		
		$(container).find('.tab-h-submenu li a', '.tab-h-container').bind('click', function(){
			
			var id = $(this).closest('ul').closest('li').find('a').attr('id');
			var label = $(this).text();
			var item = $(this);
			
			if($.isFunction(settings.callback)) {
				settings.callback.call(item, item);
			}
			
			$(this).closest('.tab-h-menu').find('li').removeClass('current');
			$(this).closest('.tab-h-menu').find('li ul:visible').slideUp(300);

			$(this).closest('ul').closest('li').addClass('current');
			$(this).closest('ul').closest('li:not(.overflowTab)').addClass('current').find('span.tab-label').text(label);

			var tabContent = $(this).closest('.tab-h-container').find('.tab-h-content:first');
			var callback =  $(this).attr('callback');

			tabContent.find('#content_'+id).fadeIn(300, function(){
				if(callback != undefined){ 
					eval(callback);
				}
			});
			
			tabContent.find('>div:not(#content_'+id+')').hide();
			MyFacture.customForm('#content_'+id);
			
		});
		

	}
	
};

window.MyTabsV2 = {

	defaultOpts: {
		start : 0
	},

	init: function(selector, options){

		var tabs = {
			options	: (options !== undefined ? $.extend(MyTabsV2.defaultOpts, options) : MyTabsV2.defaultOpts),
			tabs	: selector.find('ul.tabs-titles > li'),
			items	: selector.find('.content-wrap > *'),
			current	: -1
		};

		MyTabsV2.show(tabs);

		$.each(tabs.tabs, function(i){
			$(this).click(function(e){
				e.preventDefault();
				MyTabsV2.show(tabs, i);
			});
		});
	},

	show: function(tabs, index){

        if(tabs.current >= 0){
			$(tabs.tabs[tabs.current]).removeClass('tab-current');
			$(tabs.items[tabs.current]).removeClass('content-current');
		}

        // if(index !== undefined && index < tabs.items.length){

		// As we dont use .content-wrap to count tabs-item , count on tabs
		if (index !== undefined && index < tabs.tabs.length){
			tabs.current = index;
		}
		else if (tabs.options.start >= 0 && tabs.options.start < tabs.items.length){
			tabs.current = tabs.options.start;
        }
		else {
			tabs.current = 0;
        }

		var $currentTab = $(tabs.tabs[tabs.current]);

		if($currentTab.length > 0){
			var currentTabsLeft 	= $currentTab.position().left;
			var currentTabsTop 		= ($currentTab.outerHeight() + $currentTab[0].offsetTop) - 1;
			var currentTabsWidth 	= $currentTab.find('a').outerWidth();
	
			$("#item-underline").css({
				"width"	: currentTabsWidth+"px",
				"left"	: currentTabsLeft+"px",
				"top"	: currentTabsTop+"px"
			});
	
			$(tabs.tabs[tabs.current]).addClass('tab-current');
			$(tabs.items[tabs.current]).addClass('content-current');
		}
	}
};
